import { useNavigate } from 'react-router-dom';
import { useQueryWithMsg } from '../../utils/hooks';
import { PaddedItemsTable } from '../tables/ItemsTable';
import { FarmsQuery } from '../../queries';
import { searchBy } from '../../utils/search';
import { asRelativeTime } from '../../utils/formatters';

const COLS = [
  {
    accessor: 'name',
    displayString: 'Name',
  },
  {
    accessor: 'startYear',
    displayString: 'Start Year',
  },
  {
    accessor: ({ team }) => team?.name,
    displayString: 'Team',
    format: (team) => team || 'None',
  },
  {
    accessor: 'address',
    displayString: 'Address',
  },
  {
    accessor: 'createdAt',
    displayString: 'Created',
    format: asRelativeTime,
  },
  {
    accessor: 'objectUpdatedAt',
    displayString: 'Updated',
    format: asRelativeTime,
  },
];

const SuperadminFarmsTable = () => {
  const { msg, data } = useQueryWithMsg(FarmsQuery, {
    fetchPolicy: 'cache-and-network',
  });
  const navigate = useNavigate();
  const getItems = (itemData) => {
    const { farms } = itemData;
    return farms.map((farm) => ({
      ...farm,
      onClick: () => navigate(`${farm.id}/edit`),
    }));
  };

  return (
    <PaddedItemsTable
      data={data}
      msg={msg}
      cols={COLS}
      getItems={getItems}
      sortColumn="objectUpdatedAt"
      sortDirection="desc"
      createButton="New Farm"
      createButtonOnClick={() => navigate('new')}
      hover
      searchable
      showCount
      search={searchBy(['name', 'team.name'])}
      searchPlaceholder="Search by project name or team"
    />
  );
};

export default SuperadminFarmsTable;
